export default __webpack_public_path__ + "787c3a0930060cd3cd921a0cdc4dd400.svg";